import React, { useContext } from 'react';
import { Link, useParams } from 'react-router-dom';
import '../css/projectpage.css';

import { DataContext } from '../context/DataContext';

export default function ProjectPage() {

    const { slug } = useParams();
    const { getProject } = useContext(DataContext);

    const project = getProject(slug);
    const { title, url, git, image, altImg, code, year, description } = project;
    const myImage = image;

    const technology = code.map(item => <li>{item}</li>)
    
    return (
        <section className='project--page--container d-flex'>
            <img src={myImage} alt={altImg}/>
            <div className='project--page--data'>
                <div className='project--text'>
                    <h1>{title}</h1>
                    <div className='project--info'>
                        <span className='project--description'>
                            <h5>Description</h5>
                            <p>{description}</p>
                        </span>
                        <span className='project--tech'>
                            <h5>Technology</h5>
                            <ul className='d-flex'>{technology}</ul>
                        </span>
                        <span>
                            <h5>Year</h5>
                            <p>{year}</p>
                        </span>
                    </div>
                </div>
                <div className='project--page--buttons'>
                    <a href={url} className='button' target='_blank' rel='noreferrer'>
                        Visit the site!
                    </a>
                    <a href={`https://github.com/dpdproject/${git}`} className='button' target='_blank' rel='noreferrer'>
                        GitHub link
                    </a>
                    <Link to='/#Projects' className='btn btn-outline-secondary' id='backButton'>
                        <i className="bi bi-arrow-left link--icons"></i>
                        Go Back
                    </Link>
                </div>
            </div>
        </section>
    )
}
